@use "~theme/breakpoints";
@use "./tokens";

.card {
  @include tokens.card;
}

.desktopOnly {
  margin: 0;
  border-radius: 0;
  box-shadow: none;

  @include breakpoints.desktop {
    @include tokens.card;
  }
}
